import { FILE_UPLOAD_CTA_INPUT_ID } from '../constants';

export function openImageUploadPicker() {
  document.getElementById(FILE_UPLOAD_CTA_INPUT_ID)?.click();
}
